export default {
  VITE_APP_VERSION: import.meta.env.VITE_APP_VERSION,
  VITE_ZRIVE_API_URL: import.meta.env.VITE_ZRIVE_API_URL,
  VITE_COGNITO_USER_POOL_ID: import.meta.env.VITE_COGNITO_USER_POOL_ID,
  VITE_COGNITO_APP_ID: import.meta.env.VITE_COGNITO_APP_ID,

  DEV: import.meta.env.DEV,

  VITE_POSTHOG_HOST: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  VITE_POSTHOG_KEY: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,

  VITE_SEARCH_HOST: import.meta.env.VITE_SEARCH_HOST,
  VITE_SEARCH_KEY: import.meta.env.VITE_SEARCH_KEY,

  VITE_MAX_CAROUSEL_ITEMS: import.meta.env.VITE_MAX_CAROUSEL_ITEMS ?? 10,
  VITE_FEEDBACK_URL: import.meta.env.VITE_FEEDBACK_URL,

  ALWAYS_VISIBLE_UNIVERSITIES: ['Otra universidad no incluida'],
  ALWAYS_VISIBLE_BACHELORS: ['Otra carrera no incluida'],

  VITE_LINKEDIN_CLIENT_ID: import.meta.env.VITE_LINKEDIN_CLIENT_ID,
  VITE_LINKEDIN_REDIRECT_URL: import.meta.env.VITE_LINKEDIN_REDIRECT_URL,
}
